import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsPencilSquare } from 'react-icons/bs';

import Select from '#globalComponents/Forms/Select';

import { useAllSignatures } from '../../../models/signatures/queries';
import SignatureManagerModal from '../SignatureEditor/SignatureEditor';

const SignatureSelector = ({ value, onChange, showEditor = true }) => {
	const [isManagerOpen, setIsManagerOpen] = useState(false);
	const { data: signatures = [], isLoading } = useAllSignatures();

	const defaultSignature = signatures.find((s) => s.isDefault);

	const handleChange = (e) => {
		const newValue = e.target.value || null;
		onChange?.(newValue);
	};

	return (
		<>
			<div className="space-y-3">
				<div className="flex items-center gap-2">
					<Select value={value || ''} onChange={handleChange} disabled={isLoading} className="flex-1">
						<option value="">Keine Signatur</option>
						{signatures.map((signature) => (
							<option key={signature.id} value={signature.id}>
								{signature.name}
								{signature.isDefault ? ' (Standard)' : ''}
							</option>
						))}
					</Select>

					{showEditor && (
						<button
							type="button"
							onClick={() => setIsManagerOpen(true)}
							className="p-2 text-bgBase-800 hover:text-primary-600 hover:bg-primary-100 rounded-control transition-colors"
							title="Signaturen verwalten"
						>
							<BsPencilSquare className="h-4.5 w-4.5" />
						</button>
					)}
				</div>

				{/* Hint about default signature */}
				{!value && defaultSignature && (
					<p className="text-[11px] text-bgBase-800">
						Tipp: Standard-Signatur &quot;{defaultSignature.name}&quot; auswählen.
					</p>
				)}
			</div>

			{/* Signature Manager Modal */}
			{showEditor && (
				<SignatureManagerModal
					isOpen={isManagerOpen}
					onClose={() => setIsManagerOpen(false)}
					selectedSignatureId={value}
					onSignatureChange={(newId) => {
						if (newId) onChange?.(newId);
					}}
				/>
			)}
		</>
	);
};

SignatureSelector.propTypes = {
	value: PropTypes.string,
	onChange: PropTypes.func,
	showEditor: PropTypes.bool,
};

export default SignatureSelector;
